import React, { ReactNode } from 'react';
import { NavLink } from "react-router-dom";
import { getTrackingOp, useTrackingOp } from "../../../contexts/TrackingOpContext";
import { timeLate } from "../../../util/varibles/constants";
import { durationTxt, getOperationStatus } from "../../../util/varibles/global";
import { IPropsChildren } from "../../../util/varibles/interface";
import Id from "../../Operation/Id";
import Logo from "../../Operation/Logo";
import OperationStatus from "../../Operation/OperationStatus";
import styles from "./style.module.scss";

interface IProps extends IPropsChildren {
    icon: ReactNode;
    extand?: ReactNode
}

const Header: React.FC<IProps> = ({ icon, children, extand }) => {
    const [active] = useTrackingOp(state => state.active);
    const [step] = useTrackingOp(state => state.step);
    const [op] = useTrackingOp(state => state.op);
    const getTracking = getTrackingOp();
    const { activity_log = [], est_start_time, operation } = op || {};

    if (!operation)
        return null;

    const { status, tenant_id, id, pauses = [] } = operation;
    let estStartTime, realStartTime;

    if (step > -1) {
        estStartTime = activity_log[step] ? activity_log[step].est_start_time : 0;
        realStartTime = (activity_log[step] ? activity_log[step].real_start_time : 0) || 0;
    } else {
        estStartTime = est_start_time || 0
        realStartTime = Date.now();
    }

    const realStatus = getOperationStatus(status, pauses);

    return <div className={styles.header} data-active={active} onClick={getTracking().onExtend}>
        <div
            className={styles.title}
            data-is-late={(estStartTime - realStartTime + timeLate) < 0 ? 'true' : 'false'}
        >
            <Logo status={realStatus}>{icon}</Logo>
            <NavLink to={`/operation/${tenant_id}/${id}`}>
                <Id operation={operation} status={realStatus} />
            </NavLink>
            <OperationStatus status={realStatus} />
            {children}
            {step >= 0 && <div className={styles['operation-delta-time']}>
                - {estStartTime - realStartTime + timeLate > 0 ? 'On time' : durationTxt(estStartTime - realStartTime) + ' behind schedule'}
            </div>}
            {extand}
        </div>
        <div className={styles.headerLine} />
    </div>;
};

export default Header;